import { render, staticRenderFns } from "./EditGrupo.vue?vue&type=template&id=2a7b8e95&scoped=true"
import script from "./EditGrupo.vue?vue&type=script&lang=js"
export * from "./EditGrupo.vue?vue&type=script&lang=js"
import style0 from "./EditGrupo.vue?vue&type=style&index=0&id=2a7b8e95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7b8e95",
  null
  
)

export default component.exports